import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import LeadsActions from "./LeadsActions";
import LeadsDetail from "./LeadsDetail";
import { IoIosArrowForward } from "react-icons/io";
import { useRouteMatch, useHistory } from "react-router-dom";
import CareMagnusTable from "../../utils/CareMagnusTable";
import { formatDateToDDMMYYYY } from "../../utils/CommonFunctions";

export default function LeadsManagmentTable(props) {
  const { rows, leadData, getLeads, leadAccess } = props;
  // const [startDate, endDate] = dateRange;
  const history = useHistory();
  let { url } = useRouteMatch();

  const [leadDetail, setLeadDetail] = useState(null);

  const applyDateFilter = () => {
    getLeads();
  };

  const RedirectionIcon = (props) => {
    let { params } = props;
    const rowData = params?.row;
    return (
      <>
        {params.row.clientType === "group" ? (
          ""
        ) : (
          <IoIosArrowForward
            style={{ cursor: "pointer", fontSize: "20px" }}
            onClick={() => handleLeadsDetails(rowData?._id)}
          />
        )}
      </>
    );
  };

  const handleLeadsDetails = (id) => {
    const leadata = rows.find((item) => item._id === id);
    setLeadDetail(leadata);
    if (leadata) {
      history.replace({ pathname: `${url}/details` });
    } else {
      history.replace({ pathname: `${url}` });
    }
  };

  const columns = [
    {
      field: "name",
      headerName: "Prospect Name",
      width: 180,
    },
    { field: "referral", headerName: "Referral", flex: 1, minWidth: 120 },
    {
      field: "clientPlanType",
      headerName: "Type of Plan",
      sortable: false,
      disableColumnMenu: true,
      width: 120,
    },
    {
      field: "invoiceRate",
      headerName: "Fee Rate",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "contactNames",
      headerName: "Contact Name",
      flex: 1,
      minWidth: 140,
    },
    { field: "contactEmails", headerName: "Tel", width: 120 },
    {
      field: "contactPhones",
      headerName: "Email",
      width: 120,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "salesPerson",
      headerName: "Sales Person",
      width: 120,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "createdAt",
      headerName: "Client Add Date",
      width: 100,
      sortable: false,
      disableColumnMenu: true,
      valueFormatter: (params) => {
        return `${formatDateToDDMMYYYY(params.value)}`;
      },
    },
    {
      field: "leadsStatus",
      headerName: "Status",
      width: 110,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => <StatusButton params={params} />,
    },
    {
      id: "arrow",
      width: 50,
      numeric: true,
      disablePadding: true,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => <RedirectionIcon params={params} />,
    },
  ];

  const [selectedRows, setSelectedRows] = useState([]);
  const handleRowSelection = (rowId) => {
    setSelectedRows(rowId);
  };

  return (
    <>
      {leadDetail ? (
        <LeadsDetail
          leadDetail={leadDetail}
          handleLeadsDetails={handleLeadsDetails}
          getLeads={getLeads}
        />
      ) : (
        <>
          <LeadsActions
            leadAccess={leadAccess}
            applyDateFilter={applyDateFilter}
            leadsId={selectedRows}
            leadData={leadData}
            rowData={rows}
          />
          <Box sx={{ width: "100%" }}>
            <CareMagnusTable
              tableHeight="calc(100dvh - 254px)"
              idParam="_id"
              columns={columns}
              rows={rows}
              selectedRow={selectedRows}
              handleRowSelection={handleRowSelection}
            />
          </Box>
        </>
      )}
    </>
  );
}

const leadStatusClass = {
  success: "btn-success",
  earlyStage: "btn-secondary",
  qualified: "btn-primary",
  caseClosed: "btn-danger",
  "Added to client": "btn-warning",
};

const StatusButton = (props) => {
  let { params } = props;
  const leadsStatus = params.value;
  return (
    <>
      <button className={`btn status_btn ${leadStatusClass[leadsStatus]}`}>
        {leadsStatus === "earlyStage"
          ? "Early Stage"
          : leadsStatus === "caseClosed"
          ? "Case Closed"
          : leadsStatus}
      </button>
    </>
  );
};
